import useUserPermissions from "../../../../../../common/utils/user/permissions/use-user-permissions";
import taxiCargoContractListingUserPermissionDefinition from "./taxi-cargo-contract-listing-user-permission";

const useTaxiCargoContractListingUserPermissions = () => {
  return useUserPermissions(taxiCargoContractListingUserPermissionDefinition);
};

export default useTaxiCargoContractListingUserPermissions;
